export const createNotificationId = () => {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
		return crypto.randomUUID();
	}

	return `notification-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};
